<script setup lang="ts">
import { type IconDefinition } from '@fortawesome/fontawesome-common-types';

const {
    stops = 0,
    size = 'medium',
    stopTitle = 'توقف',
} = defineProps<{
    stops?: number;
    icon?: IconDefinition;
    rotate?: 90 | 180 | 270 | '90' | '180' | '270';
    size?: SizeConditional<IconSize>;
    stopTitle?: string;
}>();
</script>

<template>
    <div class="route-container">
        <div class="circle" />
        <div class="stops">
            <div v-if="stops > 0" class="icon-container">
                <div class="circle stops-circle" />
                <mr-typography
                    type="span"
                    size="small"
                    weight="500"
                    color="var(--cool-gray-500)"
                    class="title"
                    white-space="nowrap"
                    align="center"
                >
                    {{ stops }} {{ stopTitle }}
                </mr-typography>
            </div>
        </div>
        <mr-icon
            v-if="icon"
            :icon
            :size
            :rotation="rotate"
            color="var(--cool-gray-400)"
        />
        <div v-else class="circle" />
    </div>
</template>

<style lang="scss" scoped>
.route-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 100%;
    .circle {
        width: 6px;
        height: 6px;
        background: usePalette($p-cool-gray, 500);
        margin: 4px;
        border-radius: 100%;
        flex-shrink: 0;
        &.stops-circle {
            position: absolute;
            top: -6px;
            left: -9px;
        }
    }
    .stops {
        width: 100%;
        height: 100%;
        display: flex;
        background-image: url('/assets/files/card/dot.svg');
        background-position: top;
        background-repeat: repeat-x;
        justify-content: space-around;
        margin-top: 17px;
        .icon-container {
            position: relative;
            .title {
                top: 4px;
                position: absolute;
                left: 50%;
                min-width: 40px;
                transform: translateX(-50%);
            }
        }
    }
}
</style>
